import { Box } from '@mui/material';
import CustomBreadCrumbs from 'components/CustomBreadCrumbs';
import DocumentsTable from 'modules/documents/components/DocumentsTable';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate } from 'react-router-dom';
import { reset } from 'slices/documentsSlice';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { SmallStorageProgressBar } from '../../../../components/StorageProgressBar/SmallStorageProgressBar';
import { Flex } from 'antd';

const DocumentsTrashPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { loading } = useAppSelector((state) => state.documents);

    const handleBreadcrumbClick = () => {
        dispatch(reset());
        navigate('/documents/trash');
    };

    return (
        <>
            <Box id="notification-bar"></Box>

            <Flex justify={'space-between'}>
                <CustomBreadCrumbs
                    title={'Deleted files'}
                    loading={loading}
                    breadcrumbs={[]}
                    onRootClick={() => handleBreadcrumbClick()}
                />
                <SmallStorageProgressBar />
            </Flex>

            <DndProvider backend={HTML5Backend}>
                <DocumentsTable modeDocument={'deleted'} />
            </DndProvider>
        </>
    );
};

export default DocumentsTrashPage;
